/**
 * ログインID関連メソッド
 */
export default class LoginIdUtils {
  /** 接頭辞以外の最大長 */
  private static MAX_LENGTH_EXCEPT_PREFIX = 10

  /** 使用可能な文字の定義 */
  private static ENABLED_CHARACTER = /^[a-zA-Z0-9-_]+$/

  /**
   * 有効なログインIDかを判定する
   *
   * @param loginId ログインID
   * @param academyCode 塾コード
   * @returns 有効時：null 無効時：エラーメッセージ
   */
  public static checkLoginIdEnabled(loginId: string, academyCode: string): string | null {
    // ログインIDに含まれる文字をチェック
    if (!this.ENABLED_CHARACTER.test(loginId)) {
      return 'ログインIDに使用できるのは英数字、ハイフン(-)、アンダーバー(_)のみです'
    }

    // 塾コードで始まるかのチェック
    const prefix = `${academyCode}-`
    if (!loginId.startsWith(prefix)) {
      return 'ログインIDは、塾コード+ハイフンで始まる形で指定してください'
    }

    // 接頭辞以降の指定文字列のチェック
    const text = loginId.substring(prefix.length)
    if (text.length === 0) {
      return 'ログインIDには、塾コード以外に任意の文字列を指定してください'
    }
    if (text.length > this.MAX_LENGTH_EXCEPT_PREFIX) {
      return '指定文字列は10文字以内で入力してください'
    }

    return null
  }
}
